import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_index/_authed/referral")({
  component: RouteComponent,
  beforeLoad() {
    throw redirect({ to: "/userspace", statusCode: 302 });
  },
});

function RouteComponent() {
  return <div></div>;
}
